export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7963.7ddb6033.jpg";